module.exports = __webpack_public_path__ + "img/closed.14f12225.webp";